function onSwymLoadCallback(swat) {
  const modifyWishlistPrice = () => {
    const priceElements = document.querySelectorAll(
      ".swym-product-final-price.swym-value"
    );

    priceElements.forEach((el) => {
      let text = el.textContent.trim();

      const match = text.match(/^([^\d]*)(\d+)(?:[^\d]*(\d+))?(?:\.\d{2})?$/);

      if (match) {
        const [, currencySymbol, price1] = match;

        const cleanedPrice = `${currencySymbol}${price1}`;
        if (el.textContent !== cleanedPrice) {
          el.textContent = cleanedPrice;
        }
      }
    });
  };

  const observeDOMChanges = () => {
    const targetNode = document.body;

    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          modifyWishlistPrice();
        }
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  };

  document.addEventListener("click", (event) => {
    if (
      event.target.closest(".wishlist-button") ||
      event.target.closest(".swym-sfl-add-to-cart-btn") ||
      event.target.closest(".swym-delete-btn")
    ) {
      setTimeout(modifyWishlistPrice, 500);
    }
  });

  observeDOMChanges();
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);
